import ProductGroupDetailApp from "ProductGroup/Detail/App";
import ProductGroupNewApp from "ProductGroup/New/App";
import ProductGroupListApp from "ProductGroup/ProductGroupListApp";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const productGroupRoute: RouteObject = {
  path: "productgroup",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: ProductGroupListApp,
  }, {
    path: "new",
    loader: () => viewModel,
    Component: ProductGroupNewApp,
  }, {
    path: ":key",
    loader: () => viewModel,
    Component: ProductGroupDetailApp,
  }]
};